import { Contact } from "../../../../cores/contacts/interfaces/api/get-contacts";

export function normalizeWebsiteUrl(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
}

export function buildContactFromEmail(email: string): Contact {
  const trimmed = email.trim();

  return {
    id: `crm-custom-field-email-${trimmed}`,
    name: trimmed.split("@")[0] || trimmed,
    email: trimmed,
    reference: "",
    whatsapp: "",
    source: "crm-custom-field",
    state: 0,
    owners: [],
    fields: [],
    comments: [],
    companies: [],
    emails: [],
    socials: [],
  };
}
